import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import confetti from 'canvas-confetti'
import { Bottles, Charger, MyLocation, Share, StarWhite, Success } from '../../assests/ExportImageIcon'
import { BUS_RESULT } from './busList/BusResults'

// Static placeholder — no bus booking API exists yet, so the confirmation
// details below are hardcoded to match the reference design exactly (same
// approach as bus.jsx/findbus.jsx/busBookingDetail.jsx/busPayment.jsx). Once
// a bus API is available, this can be wired up the same way
// carRental/carBookingConfirm.jsx or venue/venueBookingSuccess.jsx are.
const BOOKING_ID = 'BUS8LK92TQ'

const BOARDING_POINT = {
    address: 'ISBT Kashmiri Gate Inside Arrival Platform Near 53 & 54',
    time: '30 Apr • 06:30 PM',
}

const DROP_POINT = {
    address: 'ISBT Kashmiri Gate Inside Arrival Platform Near 53 & 54',
    time: '30 Apr • 07:00 AM',
}

const CONTACT_DETAILS = [
    { label: 'Full Name:', value: 'Shubham Modi' },
    { label: 'Email ID:', value: 'shubhammodi820@gmail.com' },
    { label: 'Phone Number:', value: '9024250272' },
]

const PASSENGERS = [
    { name: 'Shubham Modi', seat: 'C4' },
    { name: 'Priya Modi', seat: 'C3' },
]

const PAYMENT_DETAILS = [
    { label: 'Base Fare', value: '₹3,599' },
    { label: 'Taxes & Fees', value: '₹450' },
    { label: 'Convenience Fee', value: '₹250' },
]

const IMPORTANT_INFO = [
    'Carry a valid government-issued photo ID',
    'Reach the boarding point at least 15 minutes early',
    'Seat allotment is final and non-transferable',
    'Refer to the operator for baggage allowance',
]

const BusBookingConfirm = () => {
    const navigate = useNavigate()

    // Confetti rain (top -> bottom, across the full width), matching the
    // other verticals' booking-confirmed celebration.
    useEffect(() => {
        let animationFrameId
        const animationEnd = Date.now() + 5000
        const rainFrame = () => {
            confetti({
                particleCount: 5,
                startVelocity: 15,
                gravity: 0.7,
                spread: 60,
                angle: 90,
                ticks: 300,
                scalar: 1,
                origin: { x: Math.random(), y: -0.05 },
            })
            if (Date.now() < animationEnd) {
                animationFrameId = requestAnimationFrame(rainFrame)
            }
        }
        rainFrame()
        return () => {
            if (animationFrameId) cancelAnimationFrame(animationFrameId)
        }
    }, [])

    const totalPaid = PAYMENT_DETAILS.reduce((sum, item) => sum + Number(item.value.replace(/[₹,]/g, '')), 0)

    return (
        <section className='bookingConfirm commonTopPadding commonBottomPadding'>
            <div className='container'>
                <div className='row g-4'>
                    <div className='col-md-12'>
                        <div className='bookingTextConfirm'>
                            <img src={Success} alt="" />
                            <div className='bookingHead commonGredientText'>Booking Confirmed</div>
                            <p>Your bus has been successfully booked</p>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='bookingConfirmInner'>
                            <div className='resultCard'>
                                <div className='bookingConfirmMeta'>
                                    <div className='bookingConfirmMetaLabel'>Booking ID <strong>{BOOKING_ID}</strong></div>
                                    <span className='carBookingStatusBadge'>CONFIRMED</span>
                                </div>

                                <div className='resultCard__airline mt-3'>
                                    <div>
                                        <div className='resultCard__airlineName'>{BUS_RESULT.operator}</div>
                                        <div className='resultCard__flightNo'>{BUS_RESULT.busType}</div>
                                    </div>
                                </div>

                                <div className='busResultCard__rating mt-2'>
                                    <span className='hotelCard__ratingBadge'>
                                        <img src={StarWhite} alt="" /> {BUS_RESULT.rating}
                                    </span>
                                    <span className='busResultCard__reviews'>({BUS_RESULT.reviews})</span>
                                </div>

                                <div className='busResultCard__amenities mt-2'>
                                    <img src={Charger} alt="" />
                                    <img src={MyLocation} alt="" />
                                    <img src={Bottles} alt="" />
                                </div>

                                <div className='bsFareDivider' />

                                <div className='bsFareRow'>
                                    <span>Departure:</span>
                                    <span>{BUS_RESULT.departureTime}</span>
                                </div>
                                <div className='bsFareRow'>
                                    <span>Arrival:</span>
                                    <span>{BUS_RESULT.arrivalTime}</span>
                                </div>
                                <div className='bsFareRow'>
                                    <span>Duration:</span>
                                    <span>{BUS_RESULT.duration}</span>
                                </div>
                                <div className='bsFareRow'>
                                    <span>Seats:</span>
                                    <span>{PASSENGERS.map((p) => p.seat).join(', ')}</span>
                                </div>

                                <div className='bookingConfirmActions'>
                                    <button type='button' className='bookingDownloadBtn' onClick={() => navigate('/bus')}>
                                        Book Another Bus
                                    </button>
                                    <button type='button' className='bookingShareBtn' aria-label="Share">
                                        <img src={Share} alt="" />
                                    </button>
                                </div>

                                <button
                                    type='button'
                                    className='commonBtnTransparent w-100 mt-2'
                                    onClick={() => navigate('/profile', { state: { section: 'create-group' } })}
                                >
                                    Create Splitwise Group
                                </button>
                            </div>

                            <div className='bsSection'>
                                <div className='bsSectionTitle'>Contact Details</div>
                                <div className='bsBox'>
                                    {CONTACT_DETAILS.map((item, index) => (
                                        <div className='bsFareRow' key={index}>
                                            <span>{item.label}</span>
                                            <span>{item.value}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className='bsSection'>
                                <div className='bsSectionTitle'>Passenger Details</div>
                                <div className='bsBox'>
                                    {PASSENGERS.map((passenger, index) => (
                                        <div className='bookingGuestCard' key={index}>
                                            <div className='bsFareRow'>
                                                <span>Passenger {index + 1}</span>
                                                <span>{passenger.seat}</span>
                                            </div>
                                            <div className='hotelCard__name'>{passenger.name}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className='bsSection'>
                                <div className='bsSectionTitle'>Boarding &amp; Drop Points</div>
                                <div className='bsBox'>
                                    <div className='bsSectionTitle fareBaggageTitle'>Boarding Point</div>
                                    <div className='bsFareRow'>
                                        <span>Address:</span>
                                        <span>{BOARDING_POINT.address}</span>
                                    </div>
                                    <div className='bsFareRow'>
                                        <span>Time:</span>
                                        <span>{BOARDING_POINT.time}</span>
                                    </div>
                                    <div className='bsFareDivider' />
                                    <div className='bsSectionTitle fareBaggageTitle'>Drop Point</div>
                                    <div className='bsFareRow'>
                                        <span>Address:</span>
                                        <span>{DROP_POINT.address}</span>
                                    </div>
                                    <div className='bsFareRow'>
                                        <span>Time:</span>
                                        <span>{DROP_POINT.time}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='bsSection'>
                                <div className='bsSectionTitle'>Confirmation Sent</div>
                                <div className='bsBox'>
                                    <p className='bookingConfirmSentText'>
                                        We&apos;ve sent your booking confirmation via email, SMS and WhatsApp.
                                    </p>
                                </div>
                            </div>

                            <div className='bsSection'>
                                <div className='bsSectionTitle'>Payment Details</div>
                                <div className='bsBox'>
                                    {PAYMENT_DETAILS.map((item, index) => (
                                        <div className='bsFareRow' key={index}>
                                            <span>{item.label}</span>
                                            <span>{item.value}</span>
                                        </div>
                                    ))}
                                    <div className='bsFareDivider' />
                                    <div className='bsFareRow bsFareRow--total'>
                                        <span>TOTAL AMOUNT</span>
                                        <span>₹{totalPaid.toLocaleString('en-IN')}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='bsSection'>
                                <div className='bsSectionTitle'>Important Information</div>
                                <div className='bsBox'>
                                    <ul className='bsInfoList'>
                                        {IMPORTANT_INFO.map((info, index) => (
                                            <li key={index}>{info}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BusBookingConfirm
